/* globals angular */

angular.module('trends', ['restangular', 'truncate', 'ui.router', 'infinite-scroll', 'mgcrea.ngStrap',
    'ngAnimate', 'ngTouch', 'ngSanitize', 'ui.unique', 'ui.bootstrap', 'ui.select']);

require('./ajax');
require('./api');
require('./browser_detector');
require('./config');
require('./controllers');
require('./directives');
require('./download');
require('./email_alerts');
require('./history');
require('./input');
require('./logging');
require('./modal_manager');
require('./monitor');
require('./redirect');
require('./serializer');
require('./search_box_manager');
require('./tag_manager');
require('./usage');
